import { Pipe, PipeTransform } from '@angular/core';

export enum CompareType {
  string = 0,
  integer = 1,
  date = 2,
}

@Pipe({
  name: 'orderArrayObjBy'
})


export class OrderArrayObjBy implements PipeTransform {
transform( array: Array<any>, orderField: string, orderType: boolean, compareType: CompareType ): Array<string> {
    array.sort( ( a: any, b: any ) => {
      let ae = null;
      let be = null;

      if (orderField != null) {
        ae = a[ orderField ];
        be = b[ orderField ];
      } else {
        ae = a;
        be = b;
      }

      if ( ae === undefined && be === undefined ) {
        return 0;
      }
      if ( ae === undefined && be !== undefined ) {
        return orderType ? 1 : -1;
      }
      if ( ae !== undefined && be === undefined ) {
        return orderType ? -1 : 1;
      }
      if ( ae === be ) {
        return 0;
      }

      if (compareType === CompareType.integer) {
        return orderType
          ? ((Number(ae) || 0) > (Number(be) || 0) ? -1 : 1)
          : ((Number(be) || 0) > (Number(ae) || 0) ? -1 : 1);

      } else if (compareType === CompareType.date) {
        return orderType
          ? ((Date.parse(ae) || 0) > (Date.parse(be) || 0) ? -1 : 1)
          : ((Date.parse(be) || 0) > (Date.parse(ae) || 0) ? -1 : 1);
      } else {
        return orderType
          ? (ae.toString().toLowerCase() > be.toString().toLowerCase() ? -1 : 1)
          : (be.toString().toLowerCase() > ae.toString().toLowerCase() ? -1 : 1);
      }
    });

    return array;
  }
}

